angular.module('impactx.util').directive('ixImgError', function () {
    return {
        link: function (scope, element, attrs) {
            element.bind('error', function () {
                if (attrs.src !== attrs.ixImgError) {
                    attrs.$set('src', attrs.ixImgError);
                }
            });
        }
    }
});